import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { colspan: "3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import { useLeaveStore, uwvMaximumDagloon } from '@/stores/leave'
import Money from '@/components/Money.vue'
import DaysWithMissedIncome from '@/components/DaysWithMissedIncome.vue'
import Tooltip from '@/components/Tooltip.vue'
import { formatMoney } from '@/helpers/formatMoney'
import RowWithInfo from '@/components/RowWithInfo.vue'
import { translate } from '@/helpers/translate'


export default /*#__PURE__*/_defineComponent({
  __name: 'Financial',
  setup(__props) {

const leaveStore = useLeaveStore()
const { t } = translate()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, [
        _createElementVNode("h2", {
          class: _normalizeClass(_ctx.$style.title)
        }, _toDisplayString(_unref(t)('financialTitle')), 3)
      ])
    ]),
    _createElementVNode("tr", null, [
      _hoisted_2,
      _createElementVNode("th", null, _toDisplayString(_unref(t)('financialThMom')), 1),
      _createElementVNode("th", null, _toDisplayString(_unref(t)('financialThPartner')), 1)
    ]),
    _createVNode(RowWithInfo, {
      title: _unref(t)('financialDaysOffFullyPaid')
    }, {
      info: _withCtx(() => [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(_unref(t)('appliesToRegulations', {
                    regulations: _unref(leaveStore).regulationsFullyPaid.map(regulation => _unref(t)(regulation.title)).join(', ')
                })), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("td", null, _toDisplayString(_unref(leaveStore).daysOffFullyPaid(true)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(leaveStore).daysOffFullyPaid(false)), 1)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(RowWithInfo, {
      title: _unref(t)('daysOffAtMaxUwv')
    }, {
      info: _withCtx(() => [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(_unref(t)('appliesToRegulations', {
                    regulations: _unref(leaveStore).regulationsMaxUwv.map(regulation => _unref(t)(regulation.title)).join(', ')
                })), 1),
          _createElementVNode("li", {
            innerHTML: _unref(t)('dailySalaryAtMaxUwvDescriptionHtml', { url: 'https://www.uwv.nl/particulieren/ziek/ziek-zonder-werkgever/na-ziekmelding/detail/mijn-ziektewet-uitkering/hoe-hoog-is-mijn-ziektewet-uitkering/berekening-van-uw-dagloon#:~:text=Voor%20uw%20uitkering%20geldt%20een,de%20berekening%20van%20uw%20dagloon.', maxUwv: _unref(formatMoney)(_unref(uwvMaximumDagloon)) }) 
          }, null, 8, _hoisted_3),
          (_unref(leaveStore).dailySalary(true) !== null)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_unref(t)('payoutNormalAndMissingMom', {
                        payoutPerDay: _unref(formatMoney)(_unref(leaveStore).payoutAtMaxUwv(true)),
                        normalIncomePerDay: _unref(formatMoney)(_unref(leaveStore).dailySalary(true)),
                        missedIncomePerDay: _unref(formatMoney)(_unref(leaveStore).missedIncomeAtMaxUwv(true)),
                    })), 1))
            : _createCommentVNode("", true),
          (_unref(leaveStore).dailySalary(false) !== null)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(_unref(t)('payoutNormalAndMissingPartner', {
                        payoutPerDay: _unref(formatMoney)(_unref(leaveStore).payoutAtMaxUwv(false)),
                        normalIncomePerDay: _unref(formatMoney)(_unref(leaveStore).dailySalary(false)),
                        missedIncomePerDay: _unref(formatMoney)(_unref(leaveStore).missedIncomeAtMaxUwv(false)),
                    })), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(DaysWithMissedIncome, {
          "missed-income": _unref(leaveStore).missedIncomeAtMaxUwv(true),
          days: _unref(leaveStore).daysOffAtMaxUwv(true)
        }, null, 8, ["missed-income", "days"]),
        _createVNode(DaysWithMissedIncome, {
          "missed-income": _unref(leaveStore).missedIncomeAtMaxUwv(false),
          days: _unref(leaveStore).daysOffAtMaxUwv(false)
        }, null, 8, ["missed-income", "days"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(RowWithInfo, {
      title: _unref(t)('daysOffAtSeventyPercent')
    }, {
      info: _withCtx(() => [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(_unref(t)('appliesToRegulations', {
                    regulations: _unref(leaveStore).regulations70Percent.map(regulation => _unref(t)(regulation.title)).join(', ')
                })), 1),
          _createElementVNode("li", {
            innerHTML: _unref(t)('dailySalaryAtSeventyPercentDescriptionHtml', { maxUwvSeventy: _unref(formatMoney)(_unref(uwvMaximumDagloon) * 0.7) }) 
          }, null, 8, _hoisted_6),
          (_unref(leaveStore).dailySalary(true) !== null)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, _toDisplayString(_unref(t)('payoutNormalAndMissingMom', {
                    payoutPerDay: _unref(formatMoney)(_unref(leaveStore).payoutAt70Percent(true)),
                    normalIncomePerDay: _unref(formatMoney)(_unref(leaveStore).dailySalary(true)),
                    missedIncomePerDay: _unref(formatMoney)(_unref(leaveStore).missedIncomeAt70Percent(true)),
                })), 1))
            : _createCommentVNode("", true),
          (_unref(leaveStore).dailySalary(false) !== null)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, _toDisplayString(_unref(t)('payoutNormalAndMissingPartner', {
                    payoutPerDay: _unref(formatMoney)(_unref(leaveStore).payoutAt70Percent(false)),
                    normalIncomePerDay: _unref(formatMoney)(_unref(leaveStore).dailySalary(false)),
                    missedIncomePerDay: _unref(formatMoney)(_unref(leaveStore).missedIncomeAt70Percent(false)),
                })), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(DaysWithMissedIncome, {
          "missed-income": _unref(leaveStore).missedIncomeAt70Percent(true),
          days: _unref(leaveStore).daysOffAt70Percent(true)
        }, null, 8, ["missed-income", "days"]),
        _createVNode(DaysWithMissedIncome, {
          "missed-income": _unref(leaveStore).missedIncomeAt70Percent(false),
          days: _unref(leaveStore).daysOffAt70Percent(false)
        }, null, 8, ["missed-income", "days"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(RowWithInfo, {
      title: _unref(t)('daysOffUnpaid')
    }, {
      info: _withCtx(() => [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(_unref(t)('appliesToRegulations', {
                    regulations: _unref(leaveStore).regulationsUnpaid.map(regulation => _unref(t)(regulation.title)).join(', ')
                })), 1),
          (_unref(leaveStore).dailySalary(true) !== null)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(_unref(t)('daysOffUnpaidMomCost', { dailySalary: _unref(formatMoney)(_unref(leaveStore).dailySalary(true)) } )), 1))
            : _createCommentVNode("", true),
          (_unref(leaveStore).dailySalary(false) !== null)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(_unref(t)('daysOffUnpaidPartnerCost', { dailySalary: _unref(formatMoney)(_unref(leaveStore).dailySalary(false)) } )), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(DaysWithMissedIncome, {
          "missed-income": _unref(leaveStore).missedIncomeUnpaid(true),
          days: _unref(leaveStore).daysOffUnpaid(true)
        }, null, 8, ["missed-income", "days"]),
        _createVNode(DaysWithMissedIncome, {
          "missed-income": _unref(leaveStore).missedIncomeUnpaid(false),
          days: _unref(leaveStore).daysOffUnpaid(false)
        }, null, 8, ["missed-income", "days"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_unref(t)('totalGrossMissedIncome')), 1),
      _createElementVNode("td", null, [
        _createVNode(Money, {
          "hide-zero": "",
          value: _unref(leaveStore).totalMissedIncome(true)
        }, null, 8, ["value"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(Money, {
          "hide-zero": "",
          value: _unref(leaveStore).totalMissedIncome(false)
        }, null, 8, ["value"])
      ])
    ])
  ], 64))
}
}

})